const backButtons = document.querySelectorAll(
	'.block-hero-post-standard-blog .wp-block-button--back .wp-block-button__link'
);

if (backButtons.length > 0 && window.history.length > 1) {
	const previousURL = document.referrer;

	backButtons.forEach((button) => {
		if (previousURL.includes(button.href)) {
			button.href = previousURL;
		}
	});
}
